<template>
  <OuterCasing :isScroll="isScroll">
    <LoadingComponents />
    <keep-alive include="DetailRedirect,Detail">
      <router-view></router-view>
    </keep-alive>
  </OuterCasing>
</template>

<script>
import OuterCasing from "$common/components/outer-casing";
import LoadingComponents from '$superAppUser/components/loading-components';
import '$h5sdkSrc/index.js';

export default {
  components: {
    OuterCasing,
    LoadingComponents
  },
  mounted() {
  },
  data() {
    return {
      isScroll: false,
      scrollNames: []
    }
  },
  watch: {
    $route(val) {
      this.isScroll = !!(this.$root.getIosVersion && this.$root.getIosVersion.length && this.$root.getIosVersion[0] < 12 && this.scrollNames.indexOf(val.name) !== -1);
    }
  }
};
</script>
<style lang="stylus"></style>
